import React from 'react';
import './CalendarBanner.scss';
import EventIcon from '@mui/icons-material/Event';
import SchoolIcon from '@mui/icons-material/School';

const feriados = [
  { date: new Date(2026, 1, 16), label: 'Carnaval' },
  { date: new Date(2026, 1, 17), label: 'Carnaval' },
  { date: new Date(2026, 2, 24), label: 'Día de la Memoria' },
  { date: new Date(2026, 3, 2), label: 'Día del Veterano / Jueves Santo' },
  { date: new Date(2026, 3, 3), label: 'Viernes Santo' },
  { date: new Date(2026, 3, 4), label: 'No laborable UTN Avellaneda' },
  { date: new Date(2026, 3, 7), label: 'Aniversario Partido de Avellaneda' },
  { date: new Date(2026, 4, 1), label: 'Día de los Trabajadores' },
  { date: new Date(2026, 4, 25), label: 'Revolución de Mayo' },
  { date: new Date(2026, 5, 15), label: 'Güemes (trasladado)' },
  { date: new Date(2026, 5, 20), label: 'Paso a la Inmortalidad del Gral. Belgrano' },
  { date: new Date(2026, 6, 9), label: 'Día de la Independencia' },
  { date: new Date(2026, 7, 15), label: 'Fiestas Patronales de Avellaneda' },
  { date: new Date(2026, 7, 17), label: 'Paso a la Inmortalidad del Gral. San Martín' },
  { date: new Date(2026, 7, 19), label: 'Creación Universidad Obrera Nacional' },
  { date: new Date(2026, 8, 21), label: 'Día del Estudiante' },
  { date: new Date(2026, 9, 12), label: 'Día del Respeto a la Diversidad Cultural' },
  { date: new Date(2026, 10, 20), label: 'Día de la Soberanía Nacional' },
  { date: new Date(2026, 10, 21), label: 'No laborable UTN Avellaneda' },
  { date: new Date(2026, 11, 8), label: 'Inmaculada Concepción de María' },
  { date: new Date(2026, 11, 25), label: 'Navidad' },
];

const turnosFinales = [
  { date: new Date(2026, 2, 25), label: 'Turno 1 — Marzo' },
  { date: new Date(2026, 3, 6), label: 'Turno 2 — Abril' },
  { date: new Date(2026, 4, 26), label: 'Turno 3 — Mayo' },
  { date: new Date(2026, 7, 3), label: 'Turno 4 — Julio/Agosto' },
  { date: new Date(2026, 9, 13), label: 'Turno 5 — Octubre' },
  { date: new Date(2026, 11, 7), label: 'Turno 6 — Diciembre' },
  { date: new Date(2026, 11, 14), label: 'Turno 7 — Diciembre' },
];

const getNext = (list) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return list.find(item => item.date >= today) || null;
};

const formatDate = (date) => {
  return date.toLocaleDateString('es-AR', { day: 'numeric', month: 'long' });
};

const getDaysUntil = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const diff = date - today;
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  if (days === 0) return 'hoy';
  if (days === 1) return 'mañana';
  return `en ${days} días`;
};

export const CalendarBanner = () => {
  const nextFeriado = getNext(feriados);
  const nextFinal = getNext(turnosFinales);

  if (!nextFeriado && !nextFinal) return null;

  return (
    <div className='calendar-banner'>
      {nextFeriado && (
        <div className='calendar-card feriado'>
          <EventIcon className='calendar-icon' />
          <div className='calendar-info'>
            <p className='calendar-label'>Próximo feriado</p>
            <p className='calendar-name'>{nextFeriado.label}</p>
            <p className='calendar-date'>{formatDate(nextFeriado.date)} · {getDaysUntil(nextFeriado.date)}</p>
          </div>
        </div>
      )}
      {nextFinal && (
        <div className='calendar-card final'>
          <SchoolIcon className='calendar-icon' />
          <div className='calendar-info'>
            <p className='calendar-label'>Próxima fecha de final</p>
            <p className='calendar-name'>{nextFinal.label}</p>
            <p className='calendar-date'>{formatDate(nextFinal.date)} · {getDaysUntil(nextFinal.date)}</p>
          </div>
        </div>
      )}
    </div>
  );
};
